import { render, staticRenderFns } from "./Change_password.vue?vue&type=template&id=6b1ab386&scoped=true"
import script from "./Change_password.vue?vue&type=script&lang=js"
export * from "./Change_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ab386",
  null
  
)

export default component.exports